// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"Nav_navWrapper__244_4","nav":"Nav_nav__O3-ba","joinUs":"Nav_joinUs__2JFKd","socials":"Nav_socials__1w-qx"};